"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOAST_HIDE = "TOAST_HIDE";
exports.TOAST_SHOW = "TOAST_SHOW";
exports.TOAST_DURATION = 5000;


//////////////////
// WEBPACK FOOTER
// ./packages/dotcom-core/dist/constants/toast.js
// module id = 4XlA
// module chunks = 2